import { DELIVERY_STATES } from '../../../lib/deliveryStates';

// The delivery states a manual restore may transition from — «Restaurar entrega» returns a parcel
// physically in the «buzón» to its date-consistent collectable state. Matched case-insensitively
// (the wire is lowercase; older fixtures are TitleCase). Fail closed: an unrecognized state is not
// restorable. `expired` is deliberately excluded — pickup cannot be re-enabled on an expired
// delivery (grill decision). Spellings come from the canonical constants (backend-confirmed
// underscores); the legacy hyphen/space variants are rejected on purpose rather than guessed.
const RESTORABLE_STATES = new Set<string>([
  DELIVERY_STATES.collected,
  DELIVERY_STATES.blocked,
  DELIVERY_STATES.rejected,
  DELIVERY_STATES.nonCollected,
  DELIVERY_STATES.cancelled,
]);

export function isRestorable(status: string): boolean {
  return RESTORABLE_STATES.has(status.toLowerCase());
}
